import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Tag } from 'src/app/models/tag.model';
import { Video } from 'src/app/models/video.model';
import { VideosService } from 'src/app/services/videos.service';

@Component({
  selector: 'videos-by-tag',
  templateUrl: './videos-by-tag.component.html',
  styleUrls: ['./videos-by-tag.component.scss']
})
export class VideosByTagComponent implements OnInit {

  tag: Tag = { _id: "", name: "", videos: [] }

  dataLoaded: boolean
  page: number=1
  loading: boolean
  finishedLoading: boolean

  constructor(private route: ActivatedRoute, private videosService: VideosService) { }

  ngOnInit(): void {
    this.dataLoaded = false
    this.route.queryParams
      .subscribe(params => {
        this.tag._id = params['tagId']
        this.tag.name = params['tagName']

      }, err => console.log('error', err))

    this.loadVideos()
  }

  initVideos() {
    this.page = 1
    this.tag.videos = []
    this.loadVideos()
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event: any) {
    if (window.innerHeight + window.scrollY + 800 >= document.body.offsetHeight) {
      if (!this.loading && !this.finishedLoading)
        this.loadVideos()
    }
  }

  loadVideos() {
    this.loading=true
    if (this.tag._id)
      this.videosService.getVideosByTagId(this.tag._id,this.page)
        .subscribe(d => {
          this.dataLoaded = true
          this.loading=false
          this.page++
          if (d.videos.length === 0)
            this.finishedLoading=true
          this.tag.videos.push(...d.videos)  
          console.log(this.tag.videos)
        }, err => console.log('error', err))
  }

}

